import styled from "styled-components";

export const ContainerCardMetrics = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 1rem;
  gap: 0.75rem;

  border-radius: 0.25rem;
  border: 1px solid ${({ theme }) => theme.controlPanel.borderCharts};

  min-width: 16.4rem;

  width: 100%;

  span {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 21.78px;
    color: ${({ theme }) => theme.controlPanel.textControlPanel};
    margin: 0;
  }

  p {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 29.05px;
    margin: 0;
  }

  @media (max-width: 600px) {
    width: 100%;
  }

  .title-card {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
`;
